import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const SlackConfigurationFormSchema = oz.object({
  channelId: oz.string().min(1, 'Channel ID is required'),
});

export type SlackConfigurationFormValues = oz.infer<typeof SlackConfigurationFormSchema>;
export type SlackConfigurationControl = Control<SlackConfigurationFormValues>; 